import React from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import App from '@/App.tsx'
import ErrorBoundary from '@/components/shared/ErrorBoundary.tsx'

// Global handler for uncaught module import errors (e.g., stale cache after deploy)
window.addEventListener('error', (event) => {
  const message = event.message || ''
  if (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError')
  ) {
    console.info('[Global] Module import error detected, reloading page...')
    event.preventDefault()
    window.location.reload()
  }
})

// Handle unhandled promise rejections (async module imports)
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.message || String(event.reason) || ''
  if (
    reason.includes('Failed to fetch dynamically imported module') ||
    reason.includes('Loading chunk') ||
    reason.includes('ChunkLoadError')
  ) {
    console.info('[Global] Async module import error detected, reloading page...')
    event.preventDefault()
    window.location.reload()
  }
})

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
